<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">
				รายการสมาชิก
				<small class="ml-1">({{ data.length | format(0) }} รายการ)</small>
			</h3>
		</div>

		<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
			<el-table-column label="สมาชิก" min-width="100px">
				<div slot-scope="{ row }">
					<router-link :to="`/dashboard/members/${row.id}`">
						{{ row.firstName }} {{ row.lastName }}
					</router-link>
					<br />
					{{ row.phone }}
				</div>
			</el-table-column>
			<el-table-column label="ธนาคาร" min-width="75px">
				<div slot-scope="{ row }">
					{{ row.bankCode | bankName }}
					<br />
					{{ row.bankNumber }}
				</div>
			</el-table-column>
			<el-table-column label="สถานะ" align="center" min-width="75px">
				<div slot-scope="{ row }">
					<span class="badge badge-success" v-if="row.status">สมาชิกทั่วไป</span>
					<span class="badge badge-danger" v-else>ระงับการใช้งาน</span>
				</div>
			</el-table-column>
			<el-table-column label="รายการฝาก / ถอน / อื่นๆ" align="center" min-width="125px">
				<div slot-scope="{ row }">
					<base-button type="primary" size="sm" @click="viewDeposit(row.id)">
						<i class="fas fa-th-list" /> ฝาก
					</base-button>
					<base-button type="warning" size="sm" @click="viewWithdraw(row.id)">
						<i class="fas fa-th-list" /> ถอน
					</base-button>
					<base-button type="danger" size="sm" @click="viewOther(row.id)">
						<i class="fas fa-th-list" /> อื่นๆ
					</base-button>
				</div>
			</el-table-column>
			<el-table-column label="เติมเครดิต" align="center" min-width="50px">
				<div slot-scope="{ row }">
					<!-- <base-button type="success" size="sm" @click="addCredit(row)">
						<i class="fas fa-plus" />
					</base-button> -->
					<router-link :to="`/dashboard/fix-tx?phone=${row.phone}`" class="btn btn-success btn-sm">
						<i class="fas fa-plus" />
					</router-link>
				</div>
			</el-table-column>
			<el-table-column label="ปรับสถานะ" align="center" min-width="50px">
				<div slot-scope="{ row }">
					<base-button type="danger" size="sm" @click="updateMemberStatus(row)" v-if="row.status">
						<i class="fas fa-ban" />
					</base-button>
					<base-button type="success" size="sm" @click="updateMemberStatus(row)" v-else>
						<i class="fas fa-play" />
					</base-button>
				</div>
			</el-table-column>
			<el-table-column label="แก้ไขข้อมูล" align="center" min-width="50px">
				<div slot-scope="{ row }">
					<base-button type="dark" size="sm" @click="editMember(row)">
						<i class="fas fa-wrench" />
					</base-button>
				</div>
			</el-table-column>
		</el-table>
		<div class="card-footer d-flex justify-content-between">
			<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

			<base-pagination
				class="pagination-no-border"
				:per-page="pagination.perPage"
				:total="total"
				v-model="pagination.currentPage"
			/>
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'

import moment from 'moment'
import BonusService from '../../services/bonus.service'
import tablePagination from '../../mixins/tablePagination'

export default {
	props: ['data'],
	mixins: [tablePagination([], 10)],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	methods: {
		updateMemberStatus(member) {
			this.$emit('updateStatus', member)
		},
		editMember(member) {
			this.$emit('editMember', member)
		},
		addCredit(member) {
			this.$emit('addCredit', member)
		},
		viewDeposit(memberID) {
			this.$emit('viewDeposit', memberID)
		},
		viewWithdraw(memberID) {
			this.$emit('viewWithdraw', memberID)
		},
		viewOther(memberID) {
			this.$emit('viewOther', memberID)
		},
	},
	created() {
		this.updateTableData(this.data)
	},
	watch: {
		data(v) {
			this.updateTableData(v)
		},
	},
}
</script>
